import useGetPricingWorkloads from "@entities/pricingWorkload/lib/hooks/useGetPricingWorkloads";
import { BriefClosureStatus } from "@shared/lib/types/brief";
import { useMemo } from "react";

type UseClosuresPricingPocParams = {
  userIdParam: string;
  isSuperUser: boolean;
};

export function useClosuresPricingPoc({
  userIdParam,
  isSuperUser,
}: UseClosuresPricingPocParams) {
  const { pricingWorkloadData, isPricingWorkloadLoading } =
    useGetPricingWorkloads({
      userIds: [],
      enabled: isSuperUser,
    });

  const {
    pricingWorkloadData: pricingWorkloadPerUser,
    isPricingWorkloadLoading: isPricingWorkloadPerUserLoading,
  } = useGetPricingWorkloads({
    userIds: userIdParam ? [userIdParam] : [],
    enabled: Boolean(userIdParam),
  });

  const selectedPoc = useMemo(() => {
    return (
      pricingWorkloadPerUser?.data?.find(
        (item) => item.userId === userIdParam
      ) || null
    );
  }, [pricingWorkloadPerUser, userIdParam]);

  const getTabCount = (closureStatus: BriefClosureStatus) => {
    if (!selectedPoc) {
      return null;
    }

    return closureStatus === BriefClosureStatus.Open
      ? selectedPoc.closureActiveBriefsCount
      : selectedPoc.closureClosedBriefsCount;
  };

  const pocSelectOptions =
    pricingWorkloadData?.data?.map((data) => ({
      label: `${data?.user?.firstName} ${data?.user?.lastName}`,
      value: data?.user?._id,
    })) ?? [];

  const pocSelectValue = pricingWorkloadData?.data?.find(
    (item) => item.userId === userIdParam
  )
    ? userIdParam
    : null;

  return {
    pricingWorkloadData,
    isPricingWorkloadLoading,
    selectedPoc,
    isPricingWorkloadPerUserLoading,
    getTabCount,
    pocSelectOptions,
    pocSelectValue,
  };
}
